import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';

@Directive({
  selector: '[kwHorizontalExpand]'
})

export class HorizontalExpandDirective implements AfterViewInit{
  @Input() items:NbMenuItem[]  

  constructor(private nbMenuService:NbMenuService,private el:ElementRef) { }
  
  ngAfterViewInit(): void {
    //console.log(this.items);
    this.createSubMenus(this.items)
  }

  createSubMenus(items:NbMenuItem[]){
    /* items.forEach(item => {
      item.children && 
    }) */
  }

  

}
